import { render, staticRenderFns } from "./OnsCampaignEmojiInstruction.vue?vue&type=template&id=208fec28&scoped=true"
import script from "./OnsCampaignEmojiInstruction.vue?vue&type=script&lang=js"
export * from "./OnsCampaignEmojiInstruction.vue?vue&type=script&lang=js"
import style0 from "./OnsCampaignEmojiInstruction.vue?vue&type=style&index=0&id=208fec28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208fec28",
  null
  
)

export default component.exports